module.exports = __webpack_public_path__ + "static/media/sc.ad1bcb4c.svg";